import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../../layouts';
import configBase from '../../../../configBase';
import axios from 'axios';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import ClearIcon from '@material-ui/icons/Clear';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';

class NovoPlano extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            editPlan: false,
            objEditPlan: null,
            disabledFields: true,
            loadingFields: true,
            loadingSave: false,

            name: { value: '', required: true, error: '', type: 'text' },
            codeS4: { value: '', required: true, error: '', type: 'text' },
            value: { value: '0,00', required: true, error: '', type: 'text' },
            
            costCenterId: { value: '', required: true, error: '', type: 'select' },
            costCenters: [],

            familyTable: {
                value2: { value: '0,00', required: false, error: '', type: 'text' },
                value3: { value: '0,00', required: false, error: '', type: 'text' },
                value4: { value: '0,00', required: false, error: '', type: 'text' },
                value5: { value: '0,00', required: false, error: '', type: 'text' },
                value6: { value: '0,00', required: false, error: '', type: 'text' },
            },
            abrangenciaId: { value: '', required: false, error: '', type: 'select' },
            urlContrato: { value: '', required: false, error: '', type: 'text' },
            urlAditivo: { value: '', required: false, error: '', type: 'text' },
            urlManual: { value: '', required: false, error: '', type: 'text' },
            urlGuia: { value: '', required: false, error: '', type: 'text' },
            urlMinutaContrato: { value: '', required: false, error: '', type: 'text' },
            urlMinutaAditivo: { value: '', required: false, error: '', type: 'text' },
            urlCobertura: { value: '', required: false, error: '', type: 'text' },
            typePayment: { value: 'BOLETO', required: false, error: '', type: 'select' },
            descontoAvista: { value: '0', required: false, error: '', type: 'number' },
            descontoAnual: { value: '0,00', required: false, error: '', type: 'text' },
            anual: { value: false, required: false, error: '', type: 'checkbox' },

            oldValue: { value: '0,00', required: false, error: '', type: 'text' },
            qualificacao: { value: 'Familiar', required: true, error: '', type: 'select' },
            registro: { value: '467.028/12-1', required: false, error: '', type: 'text' },
            segmentacao: { value: 'Odontológico', required: false, error: '', type: 'select' },
            area_atuacao: { value: 'Capital', required: false, error: '', type: 'text' },
            cobertura: { value: 'ROL DA ANS', required: false, error: '', type: 'text' },
            publico: { value: 'Pessoa Física', required: false, error: '', type: 'select' },
            taxaImplantacao: { value: '0,00', required: false, error: '', type: 'text' },
            uploadDocRequired: { value: true, required: false, error: '', type: 'checkbox' },
            descontoAvistaPix: { value: '0', required: false, error: '', type: 'number' },
            ativo: { value: true, required: false, error: '', type: 'boolean' },
            
            valores: [{
                qtdInicial: {value: '1', required: true, error: '', type: 'number'},
                qtdFinal: {value: '20', required: true, error: '', type: 'number'},
                valorTitular: {value: '0,00', required: true, error: '', type: 'text'},
                valorDependente: {value: '0,00', required: true, error: '', type: 'text'},
                valorAgregado: {value: '0,00', required: true, error: '', type: 'text'},
            }],

            salesmanIdDefaut: { value: '', required: false, error: '', type: 'text' },
            brokerIdDefault: { value: '', required: false, error: '', type: 'text' },
            costCenterS4: { value: '', required: false, error: '', type: 'number' },
            abrangencias: [],

            errorRequest: false,
            msgErrorRequest: '',
            successRequest: false,
            msgSuccessRequest: '',
        };
    }
    
    componentDidMount() {
        this._isMounted = true;
        this.getAbrangencias();
        this.getCostCenters(); 

        const { search } = this.props.history.location;
        const planId = new URLSearchParams(search).get('id');

        if (planId) {
            this.setState({ editPlan: true });
            this.getPlanData(planId);
        } else {
            this.setState({ editPlan: false, loadingFields: false, disabledFields: false });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getAbrangencias() {
        axios.get(`${configBase.api}Abrangencia?access_token=${localStorage.getItem('planos_t')}`)
            .then(response => {
                if (this._isMounted) {
                    this.setState({ abrangencias: response.data });
                }
            })
            .catch(error => {
                if (this._isMounted) {
                    this.setError('Erro ao carregar abrangências.');
                }
            });
    }

    getCostCenters() {
        axios.get(`${configBase.api}CostCenters?access_token=${localStorage.getItem('planos_t')}`)
            .then(response => {
                if (this._isMounted) {
                    this.setState({ costCenters: response.data });
                }
            })
            .catch(error => {
                if (this._isMounted) {
                    this.setError('Erro ao carregar centros de custo.');
                }
            });
    }

    formatValueToDisplay(value) {
        if (value === null || value === undefined || value === '') {
            return '0,00';
        }
        let numericValue = parseFloat(String(value).replace(',', '.'));
        if (isNaN(numericValue)) {
            return String(value);
        }
        return numericValue.toFixed(2).replace('.', ',');
    }

    getPlanData(planId) {
        let url = `${configBase.api}Plans/${planId}?access_token=${localStorage.getItem('planos_t')}`;
        axios.get(url)
            .then(response => {
                if (this._isMounted) {
                    let plan = response.data;
                    let state = this.state;
                    state.objEditPlan = plan;
                    
                    state.name.value = plan.name || '';
                    state.codeS4.value = plan.codeS4 || '';
                    state.value.value = this.formatValueToDisplay(plan.value);
                    state.abrangenciaId.value = plan.abrangenciaId || '';
                    state.costCenterId.value = plan.costCenterId || ''; 
                    state.urlContrato.value = plan.urlContrato || '';
                    state.urlAditivo.value = plan.urlAditivo || '';
                    state.urlManual.value = plan.urlManual || '';
                    state.urlGuia.value = plan.urlGuia || '';
                    state.urlMinutaContrato.value = plan.urlMinutaContrato || '';
                    state.urlMinutaAditivo.value = plan.urlMinutaAditivo || '';
                    state.urlCobertura.value = plan.urlCobertura || '';
                    state.typePayment.value = plan.typePayment || 'BOLETO';
                    state.descontoAvista.value = plan.descontoAvista || '0';
                    state.descontoAnual.value = this.formatValueToDisplay(plan.descontoAnual);
                    state.anual.value = Boolean(plan.anual);

                    state.oldValue.value = this.formatValueToDisplay(plan.oldValue);
                    state.qualificacao.value = plan.qualificacao || 'Familiar';
                    state.publico.value = plan.publico || 'Pessoa Física';
                    state.registro.value = plan.registro || '467.028/12-1';
                    state.segmentacao.value = plan.segmentacao || 'Odontológico';
                    state.area_atuacao.value = plan.area_atuacao || 'Capital';
                    state.cobertura.value = plan.cobertura || 'ROL DA ANS';
                    state.taxaImplantacao.value = this.formatValueToDisplay(plan.taxaImplantacao);
                    state.uploadDocRequired.value = Boolean(plan.uploadDocRequired);
                    state.salesmanIdDefaut.value = plan.salesmanIdDefaut || '';
                    state.brokerIdDefault.value = plan.brokerIdDefault || '';
                    state.costCenterS4.value = plan.costCenterS4 || '';
                    state.ativo.value = typeof plan.ativo === 'boolean' ? plan.ativo : true;

                    const isEmpresarial = plan.qualificacao === 'Empresarial';
                    if (isEmpresarial && plan.valores && plan.valores.length > 0) {
                        state.valores = plan.valores.map(val => ({
                            ...val,
                            qtdInicial: {value: val.qtdInicial, required: true, error: '', type: 'number'},
                            qtdFinal: {value: val.qtdFinal, required: true, error: '', type: 'number'},
                            valorTitular: {value: this.formatValueToDisplay(val.valorTitular), required: true, error: '', type: 'text'},
                            valorDependente: {value: this.formatValueToDisplay(val.valorDependente), required: true, error: '', type: 'text'},
                            valorAgregado: {value: this.formatValueToDisplay(val.valorAgregado), required: true, error: '', type: 'text'},
                        }));
                        state.familyTable = {
                            value2: { value: '0,00', required: false, error: '', type: 'text' },
                            value3: { value: '0,00', required: false, error: '', type: 'text' },
                            value4: { value: '0,00', required: false, error: '', type: 'text' },
                            value5: { value: '0,00', required: false, error: '', type: 'text' },
                            value6: { value: '0,00', required: false, error: '', type: 'text' },
                        };
                    } else if (plan.familyTable) {
                        state.valores = [
                            {
                                qtdInicial: {value: '0', required: true, error: '', type: 'number'},
                                qtdFinal: {value: '10000', required: true, error: '', type: 'number'},
                                valorTitular: {value: '0,00', required: true, error: '', type: 'text'},
                                valorDependente: {value: '0,00', required: true, error: '', type: 'text'},
                                valorAgregado: {value: '0,00', required: true, error: '', type: 'text'},
                            },
                        ];
                        state.familyTable.value2.value = this.formatValueToDisplay(plan.familyTable.value2);
                        state.familyTable.value3.value = this.formatValueToDisplay(plan.familyTable.value3);
                        state.familyTable.value4.value = this.formatValueToDisplay(plan.familyTable.value4);
                        state.familyTable.value5.value = this.formatValueToDisplay(plan.familyTable.value5);
                        state.familyTable.value6.value = this.formatValueToDisplay(plan.familyTable.value6);
                    }

                    state.disabledFields = false;
                    state.loadingFields = false;
                    this.setState(state);
                }
            })
            .catch(() => {
                if (this._isMounted) {
                    this.setError('Problema encontrado ao buscar dados do plano.');
                    this.setState({ loadingFields: false });
                }
            });
    }

    updateFields = (event) => {
        let { name, value, type, checked } = event.target;
        let state = this.state;
        
        if (name === 'qualificacao') {
            state.qualificacao.value = value;
            if (value === 'Empresarial') {
                state.publico.value = 'Pessoa Jurídica';
            } else if (value === 'Familiar') {
                state.publico.value = 'Pessoa Física';
            }
        }
        
        if (name === 'area_atuacao') {
            state.area_atuacao.value = value;
        }

        if (name === 'typePayment') {
            state.typePayment.value = value;
        }
        
        if (type === 'checkbox') {
            state[name].value = checked;
        } else if (name.startsWith('value') && name.length === 6) {
            state.familyTable[name].value = value;
            state.familyTable[name].error = '';
        } else {
            state[name].value = value;
            state[name].error = '';
        }
        this.setState(state);
    };

    updateSwitchField = (fieldName, checked) => {
        let state = this.state;
        state[fieldName].value = checked;
        this.setState(state);
    };

    handleFormattedValueChange = (e) => {
        const { name, value } = e.target;
        let sanitizedValue = value.replace(/[^\d,]/g, ''); 
        
        const parts = sanitizedValue.split(',');
        if (parts.length > 2) {
            sanitizedValue = parts[0] + ',' + parts.slice(1).join('');
        }
        
        const dotParts = sanitizedValue.split('.');
        if (dotParts.length > 2) {
            sanitizedValue = dotParts[0] + '.' + dotParts.slice(1).join('');
        }

        if (sanitizedValue.includes(',')) {
          sanitizedValue = sanitizedValue.replace(/\./g, '');
        }
        
        this.setState(prevState => {
            if (name.startsWith('valor')) {
                const [valorNome, index] = name.match(/(\w+)(\d+)/).slice(1);
                const newValores = [...prevState.valores];
                newValores[index][valorNome].value = sanitizedValue;
                newValores[index][valorNome].error = '';
                return { valores: newValores };
            }
            if (name.startsWith('value') && name.length === 6) {
                return {
                    familyTable: {
                        ...prevState.familyTable,
                        [name]: { ...prevState.familyTable[name], value: sanitizedValue, error: '' }
                    }
                };
            }
            return {
                [name]: { ...prevState[name], value: sanitizedValue, error: '' }
            };
        });
    };

    handleFormattedValueBlur = (e) => {
        const { name, value } = e.target;
        const valueToProcess = value.replace(/\./g, '').replace(',', '.');
        let numValue = parseFloat(valueToProcess);

        if (isNaN(numValue) || value.trim() === '') {
            numValue = 0;
        }
        const formattedDisplayValue = numValue.toFixed(2).replace('.', ',');

        this.setState(prevState => {
            if (name.startsWith('valor')) {
                const [valorNome, index] = name.match(/(\w+)(\d+)/).slice(1);
                const newValores = [...prevState.valores];
                newValores[index][valorNome].value = formattedDisplayValue;
                return { valores: newValores };
            }
            if (name.startsWith('value') && name.length === 6) {
                return {
                    familyTable: {
                        ...prevState.familyTable,
                        [name]: { ...prevState.familyTable[name], value: formattedDisplayValue }
                    }
                };
            }
            return {
                [name]: { ...prevState[name], value: formattedDisplayValue }
            };
        });
    };
    
    handleValoresChange = (index, e) => {
        const { name, value } = e.target;
        let state = this.state;
        const newValores = [...state.valores];
        
        if (name.includes('valor')) {
            let sanitizedValue = value.replace(/[^\d,]/g, '');
            newValores[index][name].value = sanitizedValue;
        } else {
            newValores[index][name].value = value;
        }
        
        newValores[index][name].error = '';
        state.valores = newValores;
        this.setState(state);
    };

    handleValoresBlur = (index, e) => {
        const { name, value } = e.target;
        const valueToProcess = value.replace(/\./g, '').replace(',', '.');
        let numValue = parseFloat(valueToProcess);

        if (isNaN(numValue) || value.trim() === '') {
            numValue = 0;
        }
        const formattedDisplayValue = numValue.toFixed(2).replace('.', ',');
        
        let state = this.state;
        const newValores = [...state.valores];
        
        if (name.includes('valor')) {
             newValores[index][name].value = formattedDisplayValue;
        }

        state.valores = newValores;
        this.setState(state);
    };
    
    addValor = () => {
        let state = this.state;
        const newValor = {
            qtdInicial: {value: '0', required: true, error: '', type: 'number'},
            qtdFinal: {value: '0', required: true, error: '', type: 'number'},
            valorTitular: {value: '0,00', required: true, error: '', type: 'text'},
            valorDependente: {value: '0,00', required: true, error: '', type: 'text'},
            valorAgregado: {value: '0,00', required: true, error: '', type: 'text'},
        };
        state.valores.push(newValor);
        this.setState(state);
    };

    removeValor = (index) => {
        let state = this.state;
        state.valores.splice(index, 1);
        this.setState(state);
    };

    handleClearAbrangencia = () => {
        let state = this.state;
        state.abrangenciaId.value = '';
        state.abrangenciaId.error = '';
        this.setState(state);
    };

    checkFields = () => {
        let state = this.state;
        let error = false;
        const fields = ['name', 'codeS4', 'value', 'costCenterId']; 
        
        state.loadingSave = true;

        fields.forEach(field => {
            if (state[field].required && !state[field].value) {
                state[field].error = 'Campo obrigatório';
                error = true;
            } else {
                state[field].error = '';
            }
        });
        
        const isEmpresarial = state.qualificacao.value === 'Empresarial';
        if (isEmpresarial) {
            if (state.valores.length === 0) {
                this.setError("É preciso adicionar ao menos uma faixa de valores.");
                error = true;
            } else {
                state.valores.forEach((valor, index) => {
                    if (valor.qtdInicial.required && (!valor.qtdInicial.value || valor.qtdInicial.value <= 0)) {
                        valor.qtdInicial.error = 'Campo obrigatório';
                        error = true;
                    }
                    if (valor.qtdFinal.required && (!valor.qtdFinal.value || valor.qtdFinal.value <= 0)) {
                        valor.qtdFinal.error = 'Campo obrigatório';
                        error = true;
                    }
                    if (valor.valorTitular.required && (!valor.valorTitular.value || this.formatValueToDisplay(valor.valorTitular.value) === '0,00')) {
                        valor.valorTitular.error = 'Campo obrigatório';
                        error = true;
                    }
                    if (valor.valorDependente.required && (!valor.valorDependente.value || this.formatValueToDisplay(valor.valorDependente.value) === '0,00')) {
                        valor.valorDependente.error = 'Campo obrigatório';
                        error = true;
                    }
                    if (valor.valorAgregado.required && (!valor.valorAgregado.value || this.formatValueToDisplay(valor.valorAgregado.value) === '0,00')) {
                        valor.valorAgregado.error = 'Campo obrigatório';
                        error = true;
                    }
                });
            }
        }
        
        this.setState(state);
        
        if (!error) {
            this.savePlan();
        } else {
            this.setState({ loadingSave: false });
            if (!this.state.msgErrorRequest) {
                this.setError('Preencher os campos de forma correta.');
            }
        }
    };
    
    savePlan() {
        const { editPlan } = this.state;
        const token = localStorage.getItem('planos_t');

        const prepareValueForBackend = (val) => {
            if (typeof val === 'string') {
                return val;
            }
            return String(val).replace('.', ',');
        };
        
        const planToSend = {
            name: this.state.name.value,
            codeS4: parseInt(this.state.codeS4.value, 10),
            value: prepareValueForBackend(this.state.value.value),
            abrangenciaId: this.state.abrangenciaId.value || '',
            costCenterId: this.state.costCenterId.value || '',
            urlContrato: this.state.urlContrato.value || '',
            urlAditivo: this.state.urlAditivo.value || '',
            urlManual: this.state.urlManual.value || '',
            urlGuia: this.state.urlGuia.value || '',
            urlMinutaContrato: this.state.urlMinutaContrato.value || '',
            urlMinutaAditivo: this.state.urlMinutaAditivo.value || '',
            urlCobertura: this.state.urlCobertura.value || '',
            typePayment: this.state.typePayment.value,
            descontoAvista: parseInt(this.state.descontoAvista.value, 10) || 0,
            descontoAnual: prepareValueForBackend(this.state.descontoAnual.value),
            anual: this.state.anual.value,
            
            oldValue: prepareValueForBackend(this.state.oldValue.value),
            qualificacao: this.state.qualificacao.value,
            registro: this.state.registro.value,
            segmentacao: this.state.segmentacao.value,
            area_atuacao: this.state.area_atuacao.value,
            cobertura: this.state.cobertura.value,
            publico: this.state.publico.value,
            taxaImplantacao: prepareValueForBackend(this.state.taxaImplantacao.value),
            uploadDocRequired: this.state.uploadDocRequired.value,
            salesmanIdDefaut: this.state.salesmanIdDefaut.value || '',
            brokerIdDefault: this.state.brokerIdDefault.value || '',
            costCenterS4: this.state.costCenterS4.value || '',
            descontoAvistaPix: parseInt(this.state.descontoAvistaPix.value, 10) || 0,
            ativo: this.state.ativo.value,
        };

        const isEmpresarial = planToSend.qualificacao === 'Empresarial';
        const isFamiliar = planToSend.qualificacao === 'Familiar';
        
        if (isEmpresarial) {
            planToSend.familyTable = {
                value2: prepareValueForBackend(this.state.familyTable.value2.value),
                value3: prepareValueForBackend(this.state.familyTable.value3.value),
                value4: prepareValueForBackend(this.state.familyTable.value4.value),
                value5: prepareValueForBackend(this.state.familyTable.value5.value),
                value6: prepareValueForBackend(this.state.familyTable.value6.value),
            };
            planToSend.valores = this.state.valores.map(v => ({
                qtdInicial: parseInt(v.qtdInicial.value, 10),
                qtdFinal: parseInt(v.qtdFinal.value, 10),
                valorTitular: prepareValueForBackend(v.valorTitular.value),
                valorDependente: prepareValueForBackend(v.valorDependente.value),
                valorAgregado: prepareValueForBackend(v.valorAgregado.value),
            }));
        } else if (isFamiliar) {
            planToSend.valores = [{
                qtdInicial: 0,
                qtdFinal: 10000,
                valorTitular: prepareValueForBackend(this.state.valores[0].valorTitular.value),
                valorDependente: prepareValueForBackend(this.state.valores[0].valorDependente.value),
                valorAgregado: prepareValueForBackend(this.state.valores[0].valorAgregado.value),
            }];
            planToSend.familyTable = {
                value2: prepareValueForBackend(this.state.familyTable.value2.value),
                value3: prepareValueForBackend(this.state.familyTable.value3.value),
                value4: prepareValueForBackend(this.state.familyTable.value4.value),
                value5: prepareValueForBackend(this.state.familyTable.value5.value),
                value6: prepareValueForBackend(this.state.familyTable.value6.value),
            };
        }

        let url = editPlan
            ? `${configBase.api}Plans/upsertWithWhere?where={"id":"${this.state.objEditPlan.id}"}&access_token=${token}`
            : `${configBase.api}Plans?access_token=${token}`;

        axios.post(url, planToSend)
            .then(() => {
                if (this._isMounted) {
                    this.setSuccess(`Plano ${editPlan ? 'atualizado' : 'adicionado'} com sucesso!`);
                    this.setState({ loadingSave: false });
                    this.props.history.push(`${process.env.PUBLIC_URL}/planos`);
                }
            })
            .catch(() => {
                if (this._isMounted) {
                    this.setState({ loadingSave: false });
                    this.setError(`Erro ao ${editPlan ? 'atualizar' : 'adicionar'} plano.`);
                }
            });
    }

    backToListPlanos = () => {
        this.props.history.push(`${process.env.PUBLIC_URL}/planos`);
    };

    setError = (msg) => {
        this.setState({ errorRequest: true, msgErrorRequest: msg });
    };

    errorClose = () => {
        this.setState({ errorRequest: false, msgErrorRequest: '' });
    };

    setSuccess = (msg) => {
        this.setState({ successRequest: true, msgSuccessRequest: msg });
    };

    successClose = () => {
        this.setState({ successRequest: false, msgSuccessRequest: '' });
    };

    render() {
        const {
            name, codeS4, value, abrangenciaId, costCenterId, familyTable, 
            editPlan, loadingFields, loadingSave, disabledFields, abrangencias, costCenters, 
            qualificacao,
            
        } = this.state;
        
        let displayTitle = editPlan ? 'EDITAR PLANO' : 'CADASTRAR NOVO PLANO';
        
        if (editPlan && abrangenciaId.value && abrangencias.length > 0) {
            const abrangencia = abrangencias.find(item => item.id === abrangenciaId.value);
            if (abrangencia) {
                displayTitle = `${name.value} - ${abrangencia.UF}`;
            }
        }
        
        const qualificacaoOptions = ['Familiar', 'Empresarial'];
        const publicoOptions = ['Pessoa Física', 'Pessoa Jurídica'];
        const segmentacaoOptions = ['Odontológico', 'Saúde'];
        const typePaymentOptions = ['BOLETO', 'CARTAO', 'DEBITO'];
        const isEmpresarial = qualificacao.value === 'Empresarial';
        const isFamiliar = qualificacao.value === 'Familiar';

        return (
            <MainLayout history={this.props.history}>
                <div id="novoPlano" className={{ flexGrow: 1 }}>
                    <Paper elevation={0} className="paper">
                        <Grid container spacing={0}>
                            <Grid item xs={12} sm={4} md={4} lg={4}>
                                <Typography variant="button" gutterBottom style={{ marginLeft: 6 }}>
                                    {displayTitle}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} lg={8} className="botaoTituloAdd">
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
                                    <Button
                                        style={{ backgroundColor: '#636d77', color: '#fff' }}
                                        variant="contained"
                                        startIcon={<ArrowBackIcon />}
                                        size="small"
                                        onClick={this.backToListPlanos}
                                        color="default"
                                    >
                                        VOLTAR
                                    </Button>
                                    <div className="containerButton" style={{ position: 'relative' }}>
                                        <Button
                                            variant="contained"
                                            style={{ backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria }}
                                            startIcon={<SaveIcon />}
                                            size="small"
                                            onClick={this.checkFields}
                                            disabled={loadingSave}
                                        >
                                            SALVAR
                                        </Button>
                                        {loadingSave && <CircularProgress size={24} className="progressButton" />}
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>

                    <div id="novoPlanoConteudo" className="contentepanel" style={{ marginTop: 40 }}>
                        <Paper className="paperForm">
                            <div className="paper">
                                <Typography variant="h6" gutterBottom className="titlePaperForm">
                                    Informações do Plano
                                </Typography>
                            </div>
                            <div>
                                <Divider />
                            </div>
                            <div className="paper">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} lg={6} className="containerButton">
                                        <TextField
                                            fullWidth
                                            error={name.error.length > 0}
                                            helperText={name.error}
                                            label={name.required ? "Nome do Plano *" : "Nome do Plano"}
                                            type={name.type}
                                            variant="outlined"
                                            size="small"
                                            name="name"
                                            value={name.value}
                                            onChange={this.updateFields}
                                            disabled={disabledFields}
                                        />
                                        {loadingFields && <CircularProgress size={24} className="progressButton" />}
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6} className="containerButton">
                                        <TextField
                                            fullWidth
                                            error={codeS4.error.length > 0}
                                            helperText={codeS4.error}
                                            label={codeS4.required ? "Código S4 *" : "Código S4"}
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            name="codeS4"
                                            value={codeS4.value}
                                            onChange={this.updateFields}
                                            disabled={disabledFields}
                                        />
                                        {loadingFields && <CircularProgress size={24} className="progressButton" />}
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                                        <TextField
                                            fullWidth
                                            error={value.error.length > 0}
                                            helperText={value.error}
                                            label={value.required ? "Valor *" : "Valor"}
                                            type={value.type}
                                            variant="outlined"
                                            size="small"
                                            name="value"
                                            value={value.value}
                                            onChange={this.handleFormattedValueChange}
                                            onBlur={this.handleFormattedValueBlur}
                                            disabled={disabledFields}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                                            }}
                                        />
                                        {loadingFields && <CircularProgress size={24} className="progressButton" />}
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                                        <TextField
                                            fullWidth
                                            select
                                            error={abrangenciaId.error.length > 0}
                                            helperText={abrangenciaId.error}
                                            label="Abrangência"
                                            variant="outlined"
                                            size="small"
                                            name="abrangenciaId"
                                            value={abrangenciaId.value}
                                            onChange={this.updateFields}
                                            disabled={disabledFields}
                                            InputProps={{
                                                endAdornment: abrangenciaId.value && (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="clear abrangencia"
                                                            onClick={this.handleClearAbrangencia}
                                                            edge="end"
                                                            size="small"
                                                        >
                                                            <ClearIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        >
                                            <MenuItem value="">Nenhuma</MenuItem>
                                            {this.state.abrangencias.map((abrangencia) => (
                                                <MenuItem key={abrangencia.id} value={abrangencia.id}>
                                                    {abrangencia.UF}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {loadingFields && <CircularProgress size={24} className="progressButton" />}
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                                        <TextField
                                            fullWidth
                                            select
                                            error={costCenterId.error.length > 0}
                                            helperText={costCenterId.error}
                                            label={costCenterId.required ? "Centro de Custo *" : "Centro de Custo"}
                                            variant="outlined"
                                            size="small"
                                            name="costCenterId"
                                            value={costCenterId.value}
                                            onChange={this.updateFields}
                                            disabled={disabledFields}
                                        >
                                            <MenuItem value="">Selecione um Centro de Custo</MenuItem>
                                            {costCenters.map((cc) => (
                                                <MenuItem key={cc.id} value={cc.id}>
                                                    {cc.name} 
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        {loadingFields && <CircularProgress size={24} className="progressButton" />}
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={4} lg={4} className="containerButton">
                                        <TextField
                                            fullWidth
                                            select
                                            error={this.state.qualificacao.error.length > 0}
                                            helperText={this.state.qualificacao.error}
                                            label="Qualificação"
                                            variant="outlined"
                                            size="small"
                                            name="qualificacao"
                                            value={this.state.qualificacao.value}
                                            onChange={this.updateFields}
                                            disabled={disabledFields}
                                        >
                                            {qualificacaoOptions.map((option) => (
                                                <MenuItem key={option} value={option}>{option}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} lg={4} className="containerButton">
                                        <TextField
                                            fullWidth
                                            error={this.state.area_atuacao.error.length > 0}
                                            helperText={this.state.area_atuacao.error}
                                            label="Área de Atuação"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            name="area_atuacao"
                                            value={this.state.area_atuacao.value}
                                            onChange={this.updateFields}
                                            disabled={disabledFields}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.ativo.value}
                                                    onChange={(e) => this.updateSwitchField('ativo', e.target.checked)}
                                                    color="primary"
                                                    disabled={disabledFields}
                                                />
                                            }
                                            label="Plano ativo"
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={12}>
                                        <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                    </Grid>
                                    
                                    <Grid item xs={12}>
                                        <Typography variant="h6" gutterBottom className="titlePaperForm">
                                            {isEmpresarial ? "Valores por Faixa de Vidas" : "Valores por Faixa Familiar"}
                                        </Typography>
                                    </Grid>
                                    
                                    {isEmpresarial ? (
                                        <>
                                            <Grid item xs={12}>
                                                {this.state.valores.map((valor, index) => (
                                                    <Grid container spacing={2} key={index} alignItems="center" style={{ marginBottom: 15 }}>
                                                        <Grid item xs={12} sm={6} md={2}>
                                                            <TextField
                                                                fullWidth
                                                                label="Qtd. Inicial"
                                                                type="number"
                                                                variant="outlined"
                                                                size="small"
                                                                name="qtdInicial"
                                                                value={valor.qtdInicial.value}
                                                                onChange={(e) => this.handleValoresChange(index, e)}
                                                                disabled={disabledFields}
                                                                error={!!valor.qtdInicial.error}
                                                                helperText={valor.qtdInicial.error}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={2}>
                                                            <TextField
                                                                fullWidth
                                                                label="Qtd. Final"
                                                                type="number"
                                                                variant="outlined"
                                                                size="small"
                                                                name="qtdFinal"
                                                                value={valor.qtdFinal.value}
                                                                onChange={(e) => this.handleValoresChange(index, e)}
                                                                disabled={disabledFields}
                                                                error={!!valor.qtdFinal.error}
                                                                helperText={valor.qtdFinal.error}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={2}>
                                                            <TextField
                                                                fullWidth
                                                                label="Valor Titular"
                                                                type="text"
                                                                variant="outlined"
                                                                size="small"
                                                                name="valorTitular"
                                                                value={valor.valorTitular.value}
                                                                onChange={(e) => this.handleValoresChange(index, e)}
                                                                onBlur={(e) => this.handleValoresBlur(index, e)}
                                                                disabled={disabledFields}
                                                                InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                                                                error={!!valor.valorTitular.error}
                                                                helperText={valor.valorTitular.error}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={2}>
                                                            <TextField
                                                                fullWidth
                                                                label="Valor Dependente"
                                                                type="text"
                                                                variant="outlined"
                                                                size="small"
                                                                name="valorDependente"
                                                                value={valor.valorDependente.value}
                                                                onChange={(e) => this.handleValoresChange(index, e)}
                                                                onBlur={(e) => this.handleValoresBlur(index, e)}
                                                                disabled={disabledFields}
                                                                InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                                                                error={!!valor.valorDependente.error}
                                                                helperText={valor.valorDependente.error}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={2}>
                                                            <TextField
                                                                fullWidth
                                                                label="Valor Agregado"
                                                                type="text"
                                                                variant="outlined"
                                                                size="small"
                                                                name="valorAgregado"
                                                                value={valor.valorAgregado.value}
                                                                onChange={(e) => this.handleValoresChange(index, e)}
                                                                onBlur={(e) => this.handleValoresBlur(index, e)}
                                                                disabled={disabledFields}
                                                                InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
                                                                error={!!valor.valorAgregado.error}
                                                                helperText={valor.valorAgregado.error}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={1}>
                                                            {this.state.valores.length > 1 && (
                                                                <IconButton onClick={() => this.removeValor(index)} disabled={disabledFields} size="small">
                                                                    <RemoveCircleOutlineIcon color="secondary" />
                                                                </IconButton>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={this.addValor}
                                                    disabled={disabledFields}
                                                    startIcon={<AddCircleOutlineIcon />}
                                                >
                                                    Adicionar Faixa
                                                </Button>
                                            </Grid>
                                        </>
                                    ) : (
                                        <>
                                            <Grid item xs={12} sm={6} md={4} lg={2} className="containerButton">
                                                <TextField
                                                    fullWidth
                                                    error={familyTable.value2.error.length > 0}
                                                    helperText={familyTable.value2.error}
                                                    label="Valor 2 Vidas (R$)"
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    name="value2"
                                                    value={familyTable.value2.value}
                                                    onChange={this.handleFormattedValueChange}
                                                    onBlur={this.handleFormattedValueBlur}
                                                    disabled={disabledFields}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={2} className="containerButton">
                                                <TextField
                                                    fullWidth
                                                    error={familyTable.value3.error.length > 0}
                                                    helperText={familyTable.value3.error}
                                                    label="Valor 3 Vidas (R$)"
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    name="value3"
                                                    value={familyTable.value3.value}
                                                    onChange={this.handleFormattedValueChange}
                                                    onBlur={this.handleFormattedValueBlur}
                                                    disabled={disabledFields}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={2} className="containerButton">
                                                <TextField
                                                    fullWidth
                                                    error={familyTable.value4.error.length > 0}
                                                    helperText={familyTable.value4.error}
                                                    label="Valor 4 Vidas (R$)"
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    name="value4"
                                                    value={familyTable.value4.value}
                                                    onChange={this.handleFormattedValueChange}
                                                    onBlur={this.handleFormattedValueBlur}
                                                    disabled={disabledFields}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={2} className="containerButton">
                                                <TextField
                                                    fullWidth
                                                    error={familyTable.value5.error.length > 0}
                                                    helperText={familyTable.value5.error}
                                                    label="Valor 5 Vidas (R$)"
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    name="value5"
                                                    value={familyTable.value5.value}
                                                    onChange={this.handleFormattedValueChange}
                                                    onBlur={this.handleFormattedValueBlur}
                                                    disabled={disabledFields}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4} lg={2} className="containerButton">
                                                <TextField
                                                    fullWidth
                                                    error={familyTable.value6.error.length > 0}
                                                    helperText={familyTable.value6.error}
                                                    label="Valor 6 Vidas (R$)"
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    name="value6"
                                                    value={familyTable.value6.value}
                                                    onChange={this.handleFormattedValueChange}
                                                    onBlur={this.handleFormattedValueBlur}
                                                    disabled={disabledFields}
                                                />
                                            </Grid>
                                        </>
                                    )}

                                    <Grid item xs={12}>
                                        <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography variant="h6" gutterBottom className="titlePaperForm">
                                            URLs de Documentos
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                        <TextField
                                            fullWidth
                                            error={this.state.urlContrato.error.length > 0}
                                            helperText={this.state.urlContrato.error}
                                            label="URL Contrato"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            name="urlContrato"
                                            value={this.state.urlContrato.value}
                                            onChange={this.updateFields}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                        <TextField
                                            fullWidth
                                            error={this.state.urlAditivo.error.length > 0}
                                            helperText={this.state.urlAditivo.error}
                                            label="URL Aditivo"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            name="urlAditivo"
                                            value={this.state.urlAditivo.value}
                                            onChange={this.updateFields}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                        <TextField
                                            fullWidth
                                            error={this.state.urlManual.error.length > 0}
                                            helperText={this.state.urlManual.error}
                                            label="URL Manual"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            name="urlManual"
                                            value={this.state.urlManual.value}
                                            onChange={this.updateFields}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                        <TextField
                                            fullWidth
                                            error={this.state.urlGuia.error.length > 0}
                                            helperText={this.state.urlGuia.error}
                                            label="URL Guia"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            name="urlGuia"
                                            value={this.state.urlGuia.value}
                                            onChange={this.updateFields}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                        <TextField
                                            fullWidth
                                            error={this.state.urlMinutaContrato.error.length > 0}
                                            helperText={this.state.urlMinutaContrato.error}
                                            label="URL Minuta Contrato"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            name="urlMinutaContrato"
                                            value={this.state.urlMinutaContrato.value}
                                            onChange={this.updateFields}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                        <TextField
                                            fullWidth
                                            error={this.state.urlMinutaAditivo.error.length > 0}
                                            helperText={this.state.urlMinutaAditivo.error}
                                            label="URL Minuta Aditivo"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            name="urlMinutaAditivo"
                                            value={this.state.urlMinutaAditivo.value}
                                            onChange={this.updateFields}
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4} lg={4}>
                                        <TextField
                                            fullWidth
                                            error={this.state.urlCobertura.error.length > 0}
                                            helperText={this.state.urlCobertura.error}
                                            label="URL Cobertura"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            name="urlCobertura"
                                            value={this.state.urlCobertura.value}
                                            onChange={this.updateFields}
                                            disabled={true}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={12}>
                                        <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography variant="h6" gutterBottom className="titlePaperForm">
                                            Pagamento
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3} lg={3}>
                                        <TextField
                                            fullWidth
                                            select
                                            error={this.state.typePayment.error.length > 0}
                                            helperText={this.state.typePayment.error}
                                            label="Tipo de Pagamento"
                                            variant="outlined"
                                            size="small"
                                            name="typePayment"
                                            value={this.state.typePayment.value}
                                            onChange={this.updateFields}
                                            disabled={disabledFields}
                                        >
                                            <MenuItem value="BOLETO">BOLETO</MenuItem>
                                            <MenuItem value="CARTAO">CARTÃO</MenuItem>
                                        </TextField>
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={3} lg={3}>
                                        <TextField
                                            fullWidth
                                            error={this.state.descontoAvista.error.length > 0}
                                            helperText={this.state.descontoAvista.error}
                                            label="Desconto à Vista (%)"
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            name="descontoAvista"
                                            value={this.state.descontoAvista.value}
                                            onChange={this.updateFields}
                                            disabled={disabledFields}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={12} sm={6} md={3} lg={3}>
                                        <TextField
                                            fullWidth
                                            error={this.state.descontoAnual.error.length > 0}
                                            helperText={this.state.descontoAnual.error}
                                            label="Desconto Anual (R$)"
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            name="descontoAnual"
                                            value={this.state.descontoAnual.value}
                                            onChange={this.handleFormattedValueChange}
                                            onBlur={this.handleFormattedValueBlur}
                                            disabled={disabledFields}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3} lg={3}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.anual.value}
                                                    onChange={this.updateFields}
                                                    name="anual"
                                                    color="primary"
                                                    disabled={disabledFields}
                                                />
                                            }
                                            label="Anual"
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                    </Grid>
                                    
                                </Grid>
                            </div>
                        </Paper>
                    </div>

                    <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose}>
                        <MuiAlert className="snackbarStyle" onClose={this.errorClose} severity="error" variant="filled" elevation={6}>
                            {this.state.msgErrorRequest}
                        </MuiAlert>
                    </Snackbar>

                    <Snackbar open={this.state.successRequest} autoHideDuration={1000} onClose={this.successClose}>
                        <MuiAlert className="snackbarStyle" onClose={this.successClose} severity="success" variant="filled" elevation={6}>
                            {this.state.msgSuccessRequest}
                        </MuiAlert>
                    </Snackbar>
                </div>
            </MainLayout>
        );
    }
}

NovoPlano.propTypes = {
    history: PropTypes.object,
};

export default withRouter(NovoPlano);